import { gql } from 'src/generated/gql';

export const PHARMACIES_QUERY = gql(`
  query Pharmacies(
    $city: String, 
    $name: String, 
    $recommendation: staff_RecommendationType, 
    $state: String, 
    $zip: String, 
    $page: Int, 
    $pageSize: Int
  ) {
    staff_pharmacies(
      city: $city, 
      name: $name, 
      recommendation: $recommendation, 
      state: $state, 
      zip: $zip,
      page: $page,
      pageSize: $pageSize
    ) {
      pharmacies {
        id
        ncpdpId
        doseSpotIds
        name
        street1
        street2
        city
        state
        zip
        phone
        fax
        recommendation
        recommendationReasons
        recommendationNote
      }
      totalCount
      pageCount
      currentPage
      hasNextPage
      hasPreviousPage
    }
  }
`);
